import { cx } from "@/lib/tailwind-utils";

interface BaseStepCardProps extends React.HTMLAttributes<HTMLDivElement> {
  isSelected?: boolean;
  size?: "sm" | "md";
}

export function BaseStepCard({
  isSelected,
  size = "md",
  className,
  children,
  onClick,
  ...props
}: BaseStepCardProps) {
  return (
    <div
      className={cx(
        "rounded-lg border bg-background transition-colors",
        size === "sm" ? "py-2 px-3" : "py-3 px-4",
        onClick && "cursor-pointer hover:border-primary/40",
        isSelected ? "border-primary ring-1 ring-primary/30" : "border-border",
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

export function StepCardBadge({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cx(
        "shrink-0 flex items-center justify-center rounded-md text-tiny",
        className,
      )}
    >
      {children}
    </span>
  );
}
